import { Chip } from "@mui/material";

export default function EnvBadge() {
  const isDev = window.location.hostname.startsWith("dev.");
  if (!isDev) return null;
   return (
    <Chip
      label="ENV: DEV"
      size="small"
      color="warning"
      variant="outlined"
      sx={{
        mx: "auto", // centré horizontalement dans la Toolbar
      }}
    />
  );
}
